import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ConfigConstants } from '../../config/config-constants';
import { ConfigService } from '../../services/config/config.service';
import { UserMasterService } from '../../services/user-master/user-master.service';

@Component({
    selector: 'pace-core-app-header',
    templateUrl: './app-header.component.html',
    styleUrls: ['./app-header.component.scss'],
})
export class AppHeaderComponent implements OnInit, OnDestroy {
    public gid: string;
    public faUser = faUser;
    public displaySync = true;

    private navigationEndSubscription: Subscription;
    public constructor(
        private readonly configService: ConfigService,
        private readonly router: Router,
        private readonly userMasterService: UserMasterService,
    ) {
        if (this.userMasterService.isPaceOnlineUser()) {
            this.navigationEndSubscription = this.router.events
                .pipe(filter((event) => event instanceof NavigationEnd))
                .subscribe(() => {
                    this.displaySync = this.router.url.indexOf(ConfigConstants.routeUrlConfirmation) < 0;
                });
        }
    }

    public ngOnInit(): void {
        this.gid = this.configService.getUserFrontId();
    }

    public ngOnDestroy(): void {
        if (typeof this.navigationEndSubscription !== 'undefined') {
            this.navigationEndSubscription.unsubscribe();
        }
    }
}
